module.exports = __webpack_public_path__ + "LatoLatin-BoldItalic.2538f760e9fb5f5ec46f.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-BoldItalic.woff
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-BoldItalic.woff
// module chunks = styles